import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, image }) {
  const fullTitle = title ? `${title} | House of Sample` : 'House of Sample — Focus On Quality';
  const desc = description || 'House of Sample offers premium sample catalogues, books, hangers, waterfalls and swatches for the textile industry. Focus On Quality.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content="website" />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
}
